export default __webpack_public_path__ + "static/media/Keys_to.6622460d.png";